import React, { Component } from "react";
import Courses from "./../components/courses";
import SearchBox from "./../components/searchBox";
import createHistory from "history/createBrowserHistory";
import PropTypes from "prop-types";
import fetchWP from "../utils/fetchWP";
import ListGroup from "./../components/listGroup";
import { Html5Entities } from "html-entities";

const history = createHistory();
const uri = "";

export default class Shortcode extends Component {
  state = {
    isLoading: false,
    courses: "",
    categories: [],
    selectedcategory: "",
    pageTitle: "",
    morepages: false,
    currentPage: 1,
    searchQuery: ""
  };

  constructor(props) {
    super(props);
    this.fetchWP = new fetchWP({
      restURL: this.props.wpObject.api_url,
      restNonce: this.props.wpObject.api_nonce
    });

    this.uri = this.props.wpObject.uri;

    //this.getSetting();
  }

  componentDidMount() {
    const {
      courses,
      morepages,
      selectedcategory: selectedCategoryId,
      categories: categoriesList
    } = this.props.wpObject;

    const allCategoriesItem = { id: "", name: "All courses" };
    const categories = [allCategoriesItem, ...categoriesList];
    const selectedCategory = categories.find(x => x.id === selectedCategoryId);

    this.setState({
      courses,
      morepages,
      categories,
      //selectedcategory: (selectedcategory != "") ? selectedcategory : allCategoriesItem
      selectedcategory: selectedCategory,
      pageTitle: this.getTitle(selectedCategory, categories)
    });

    jQuery(window).scroll(() => {
      if (
        morepages === false ||
        this.state.isLoading ||
        this.state.currentPage == 1
      ) {
        return;
      }

      // This is then function used to detect if the element is scrolled into view
      function elementScrolled(elem) {
        var docViewTop = jQuery(window).scrollTop();
        var docViewBottom = docViewTop + jQuery(window).height();
        if (!jQuery(elem).offset()) {
          return;
        }
        var elemTop = jQuery(elem).offset().top;
        return elemTop <= docViewBottom && elemTop >= docViewTop;
      }

      // This is where we use the function to detect if ".box2" is scrolled into view, and when it is add the class ".animated" to the <p> child element
      if (elementScrolled(".js-pagination-container")) {
        this.loadMore();
      }
    });
  }

  getPagedData = () => {
    const { currentPage, searchQuery, courses: allCourses } = this.state;

    let filtered = allCourses;
    if (searchQuery)
      filtered = allCourses.filter(m =>
        m.title.toLowerCase().includes(searchQuery.toLowerCase())
      );
    // else if (selectedcategory && selectedcategory.id)
    //   filtered = allCourses.filter(m => m.genre.id === selectedcategory.id);

    //const sorted = _.orderBy(filtered, [sortColumn.path], [sortColumn.order]);

    //const movies = paginate(sorted, currentPage, pageSize);
    const courses = filtered;

    return { totalCount: filtered.length, courses };
  };

  getCourses = (page, cat) => {
    // if (page == 1) {
    //   jQuery("html, body").animate(
    //     {
    //       scrollTop: jQuery("h1").offset().top
    //     },
    //     500
    //   );
    // }

    if (cat) {
      history.push(this.uri + "/course-category/" + cat + "/");
    } else {
      history.push(this.uri + "/courses/");
    }

    this.setState({ isLoading: true });

    this.fetchWP.get("courses", { akpage: page, akcat: cat }).then(
      json => {
        const { posts: newCourses, morepages } = json;
        const { courses: originalCourses } = this.state;

        if (page == 1) {
          var courses = newCourses;
        } else {
          var courses = originalCourses.concat(newCourses);
        }

        this.setState({ courses, morepages, isLoading: false });
      },
      err => console.log("error", err)
    );
  };

  handleSearch = query => {
    this.setState({
      searchQuery: query,
      selectedcategory: null,
      currentPage: 1
    });
  };

  loadMore = () => {
    let { currentPage } = this.state;
    currentPage++;
    this.setState(
      { currentPage: currentPage },
      this.getCourses(currentPage, this.state.selectedcategory.id)
    );
  };

  getTitle = (selectedcategory, categories) => {
    return selectedcategory.id
      ? categories.find(x => x.id === selectedcategory.id).name
      : "Courses";
  };

  handlecategorieselect = cat => {
    if (this.state.isLoading || this.state.selectedcategory.id === cat.id)
      return;

    this.setState(
      {
        selectedcategory: cat,
        searchQuery: "",
        currentPage: 1,
        courses: [],
        isLoading: true,
        pageTitle: this.getTitle(cat, this.state.categories)
      },
      this.getCourses(1, cat.id)
    );
  };

  render() {
    const {
      isLoading,
      currentPage,
      sortColumn,
      morepages,
      searchQuery
    } = this.state;
    const { totalCount, courses } = this.getPagedData();

    return (
      <React.Fragment>
        {/* <div className="row" style={{ marginBottom: "20px" }}>
          <SearchBox value={searchQuery} onChange={this.handleSearch} />
        </div> */}

        <div className="col-md-3">
          <ListGroup
            items={this.state.categories}
            selectedItem={this.state.selectedcategory}
            disabled={this.state.isLoading}
            onItemSelect={this.handlecategorieselect}
          />
        </div>
        <div className="col-md-9">
          <h1 className="page-title">
            {Html5Entities.decode(this.state.pageTitle)}
          </h1>
          <Courses courses={courses} />
          {morepages && <div className="row js-pagination-container" />}
          {isLoading && (
            <React.Fragment>
              <div className="row">
                <div className="col-sm-12 text-center">
                  <div className="lds-css">
                    <div
                      style={{ width: "100%", height: "100%" }}
                      className="lds-facebook"
                    >
                      <div />
                      <div />
                      <div />
                    </div>
                  </div>
                </div>
              </div>
            </React.Fragment>
          )}
          {morepages && currentPage === 1 && !isLoading && (
            <React.Fragment>
              <div className="row mb-3" style={{ margin: "0 auto" }}>
                <div className="text-center" style={{ margin: "0 auto" }}>
                  <button
                    onClick={this.loadMore}
                    className="btn btn-lg btn-primary"
                  >
                    Load more
                  </button>
                </div>
              </div>
            </React.Fragment>
          )}
          {/* <p>Title: {this.props.wpObject.title}</p> */}
        </div>
      </React.Fragment>
    );
  }
}

Shortcode.propTypes = {
  wpObject: PropTypes.object
};
